module.exports = __webpack_public_path__ + "static/media/notfound-2400.d407d776.jpg";